import { DEFAULT_THEME } from "./Default";
import type { PartialTheme, Theme } from "./types";

const SLOW_BURN_COLORS: PartialTheme = {
  light: {
    "--brand": "#17141F",
    "--brand-button-text": "#FFFFFF",
    "--color-community-header-background": "#EBCE8D",
    "--color-community-header-text": "#17141F",
    "--color-community-sidebar-background": "#EBCE8D",
    "--color-community-sidebar-text": "#17141F",
    "--color-community-sidebar-active-background": "#17141F",
    "--color-community-active-item-text-color": "#FAF2E1",
    "--color-community-header-hover-background": "#D5B778",
    "--color-community-sidebar-hover-background": "#D5B778",
    "--color-online-background": "#E84731",
    "--color-community-sidebar-badge-background": "#617276",
    "--color-community-header-active-text": "#17141F",
    "--color-community-header-active-background": "#D5B778",
  },
  dark: {
    "--brand": "#E6C885",
    "--brand-button-text": "#FFFFFF",
    "--color-community-header-background": "#17141F",
    "--color-community-header-text": "#EBCE8D",
    "--color-community-sidebar-background": "#17141F",
    "--color-community-sidebar-text": "#EBCE8D",
    "--color-community-sidebar-active-background": "#E6C885",
    "--color-community-active-item-text-color": "#000000",
    "--color-community-header-hover-background": "#25323A",
    "--color-community-sidebar-hover-background": "#25323A",
    "--color-online-background": "#E84731",
    "--color-community-sidebar-badge-background": "#617276",
    "--color-community-header-active-text": "#EBCE8D",
    "--color-community-header-active-background": "#25323A",
  },
};

export const SLOW_BURN_THEME: Theme = {
  light: {
    ...DEFAULT_THEME.light,
    ...SLOW_BURN_COLORS.light,
  },
  dark: {
    ...DEFAULT_THEME.dark,
    ...SLOW_BURN_COLORS.dark,
  },
};
